export default {
  // Page Title
  'products.title': '寻找并定制化妆品包装',
  'products.subtitle': '搜索经过验证的包装产品，比较规格，并请求定制包装报价。',

  // Search
  'products.pageTitle': '寻找您的化妆品包装',
  'products.search.placeholder': '按产品名称、容量、材质或 SKU 搜索',
  'products.search.button': '搜索',
  'products.search.imageSearch': '按图片搜索',

  // Category Tabs
  'products.category.airless': '真空瓶',
  'products.category.pump': '泵头瓶',
  'products.category.spray': '喷雾瓶',
  'products.category.dropper': '滴管瓶',
  'products.category.cream': '膏霜罐',
  'products.category.foam': '泡沫瓶',
  'products.category.tubes': '软管',
  'products.category.caps': '盖与泵头',
  'products.category.sample': '样品容器',
  'products.category.aluminum': '铝制容器',
  'products.category.glass': '玻璃容器',
  'products.category.pet': 'PET / PETG 瓶',
  'products.category.all': '全部',

  // Sidebar
  'products.sidebar.title': '分类',
  'products.sidebar.noCategories': '暂无分类',

  // Category tree (sidebar)
  'products.categories.glass': '玻璃容器',
  'products.categories.glass.toner': '爽肤水瓶',
  'products.categories.glass.creamJar': '玻璃膏霜罐',
  'products.categories.glass.ampoule': '玻璃安瓿瓶',
  'products.categories.petg': 'PETG/PET 塑料容器',
  'products.categories.petg.serum': '精华液瓶',
  'products.categories.petg.toner': '爽肤水瓶',
  'products.categories.petg.creamJar': 'PETG/PET 膏霜罐',
  'products.categories.petg.shampoo': '大容量洗发水瓶',
  'products.categories.airless': '真空容器',
  'products.categories.airless.serum': '精华液瓶',
  'products.categories.airless.toner': '真空爽肤水瓶',
  'products.categories.airless.creamJar': '真空膏霜罐',
  'products.categories.specialty': '特殊容器',
  'products.categories.specialty.syringe': '注射器型',
  'products.categories.specialty.powder': '粉盒容器',
  'products.categories.specialty.cleansingPad': '清洁棉片罐',
  'products.categories.specialty.sample': '样品容器',
  'products.categories.specialty.accessories': '配件/耗材',
  'products.categories.tubes': '软管',
  'products.categories.tubes.eyeCream': '眼霜软管',
  'products.categories.tubes.flipScrew': '翻盖/螺旋盖软管',
  'products.categories.tubes.brushSponge': '刷头/海绵头',
  'products.categories.tubes.rollerComb': '滚珠/梳头软管',
  'products.categories.tubes.airlessPump': '真空泵软管',
  'products.categories.tubes.makeup': '彩妆软管',
  'products.categories.tubes.toothpaste': '牙膏软管',
  'products.categories.tubes.aluminum': '铝管',
  'products.categories.pumpsDroppers': '泵头与滴管',
  'products.categories.pumpsDroppers.mist': '细雾喷头',
  'products.categories.pumpsDroppers.dropper': '滴管',
  'products.categories.pumpsDroppers.oilPump': '精油泵',
  'products.categories.pumpsDroppers.serumPump': '精华液泵',
  'products.categories.pumpsDroppers.shampooPump': '洗发水泵',
  'products.categories.pumpsDroppers.trigger': '扳机喷枪',
  'products.categories.pumpsDroppers.caps': '盖子/封口',
  'products.categories.sheetPouch': '膜布（袋）',
  'products.categories.sheetPouch.mask': '面膜袋',
  'products.categories.sheetPouch.cleansing': '清洁（护肤）用',
  'products.categories.sheetPouch.specialty': '特殊袋',
  'products.categories.sheetPouch.pouch': '袋',
  'products.categories.boxes': '盒子/纸箱',
  'products.categories.boxes.folding': '折叠盒/单体盒',
  'products.categories.boxes.giftSet': '礼盒/套装盒',
  'products.categories.boxes.round': '圆形（多边形）盒',
  'products.categories.boxes.outer': '外箱',
  'products.categories.makeup': '彩妆容器',
  'products.categories.makeup.cushion': '气垫盒',
  'products.categories.makeup.lip': '唇部包装',
  'products.categories.makeup.puff': '粉扑',
  'products.categories.makeup.other': '其他',
  'products.categories.misc': '其他',
  'products.categories.misc.labels': '标签/贴纸',
  'products.categories.misc.pvcFilm': 'PVC收缩膜',

  // Filters
  'products.filters.title': '筛选',
  'products.filters.category': '分类',
  'products.filters.capacity': '容量',
  'products.filters.material': '材质',
  'products.filters.shape': '形状',
  'products.filters.neckSize': '瓶口尺寸 / 盖尺寸',
  'products.filters.usage': '用途 / 应用',
  'products.filters.priceRange': '价格区间',
  'products.filters.moqRange': '起订量区间',
  'products.filters.moqAvailable': '可提供起订量',
  'products.filters.inStock': '有库存',
  'products.filters.clearAll': '清除筛选',
  'products.filters.apply': '应用筛选',
  'products.filters.showResults': '显示结果',
  'products.filters.mobileTitle': '筛选产品',
  'products.filters.supplyType': '供应类型',
  'products.filters.allSupplyTypes': '全部供应类型',
  'products.filters.availabilityStatus': '库存情况',
  'products.filters.allAvailability': '全部库存情况',

  // Capacity options
  'products.capacity.5ml': '5ml',
  'products.capacity.10ml': '10ml',
  'products.capacity.15ml': '15ml',
  'products.capacity.20ml': '20ml',
  'products.capacity.30ml': '30ml',
  'products.capacity.50ml': '50ml',
  'products.capacity.60ml': '60ml',
  'products.capacity.100ml': '100ml',
  'products.capacity.120ml': '120ml',
  'products.capacity.150ml': '150ml',
  'products.capacity.200ml': '200ml',
  'products.capacity.250ml': '250ml',
  'products.capacity.300ml': '300ml',
  'products.capacity.500ml': '500ml',

  // Material options
  'products.material.pet': 'PET',
  'products.material.petg': 'PETG',
  'products.material.pp': 'PP',
  'products.material.pe': 'PE',
  'products.material.abs': 'ABS',
  'products.material.acrylic': '亚克力',
  'products.material.glass': '玻璃',
  'products.material.aluminum': '铝',
  'products.material.pcr': 'PCR',
  'products.material.mono': '单一材质',

  // Toolbar
  'products.toolbar.found': '找到 {{count}} 个包装产品',
  'products.toolbar.found_one': '找到 {{count}} 个包装产品',
  'products.toolbar.clearFilters': '清除筛选',
  'products.toolbar.sortBy': '排序',
  'products.toolbar.gridView': '网格',
  'products.toolbar.listView': '列表',
  'products.toolbar.allCategories': '全部分类',

  // Sort options
  'products.sort.newest': '最新',
  'products.sort.nameAsc': '产品名称 A-Z',
  'products.sort.nameDesc': '产品名称 Z-A',
  'products.sort.priceLow': '预估价格从低到高',
  'products.sort.priceHigh': '预估价格从高到低',
  'products.sort.capacityLow': '容量：从低到高',
  'products.sort.capacityHigh': '容量：从高到低',
  'products.sort.recentlyUpdated': '最近更新',

  // Availability Status
  'products.availability.available': '有货',
  'products.availability.limitedStock': '库存有限',
  'products.availability.checkAvailability': '需确认库存',
  'products.availability.madeToOrder': '按订单生产',

  // Product Card
  'products.card.sku': 'SKU: {{sku}}',
  'products.card.noSku': 'SKU: —',
  'products.card.moq': 'MOQ: {{moq}} 件',
  'products.card.moqFree': '小批量 (免费)',
  'products.card.finishedProduct': '成品',
  'products.card.delivery': '交付：{{days}} 天',
  'products.card.moqShort': 'MOQ: {{moq}}',
  'products.card.leadTime': '交货期',
  'products.card.leadTimeDaysSingle': '{{days}} 天',
  'products.card.leadTimeDaysRange': '{{min}}–{{max}} 天',
  'products.card.capacityMl': '{{ml}}ml',
  'products.card.deliveryDays': '交付：{{days}} 天',
  'products.card.deliveryLabel': '交付',
  'products.card.orderMethod': '订购方式',
  'products.card.basePrice': '基础价格',
  'products.card.specsSeparator': '|',
  'products.card.priceApprox': '约 {{currency}} {{price}} / 件',
  'products.card.priceEstimated': '起价 {{currency}} {{price}} / 件',
  'products.card.priceNote': '审核后确定最终报价',
  'products.card.requestQuote': '请求报价',
  'products.card.viewDetails': '查看详情',
  'products.card.aiPreview': 'AI 预览',
  'products.card.checkAvailability': '确认库存',
  'products.card.saved': '已收藏',
  'products.card.save': '收藏',
  'products.card.loginToSave': '登录后收藏',

  // Specs
  'products.specs.capacity': '容量',
  'products.specs.material': '材质',
  'products.specs.shape': '形状',
  'products.specs.neckSize': '瓶口尺寸',
  'products.specs.size': '尺寸',

  // Empty State
  'products.empty.title': '未找到产品',
  'products.empty.message': '请调整筛选条件，或上传参考图片以查找相似的包装。',
  'products.empty.noAvailable': '未找到有货的产品。请调整筛选条件或查看其他库存情况。',
  'products.empty.noLimitedStock': '未找到库存有限的产品。请调整筛选条件。',
  'products.empty.noCheckAvailability': '未找到需确认库存的产品。请调整筛选条件。',
  'products.empty.noMadeToOrder': '未找到按订单生产的产品。请调整筛选条件。',
  'products.empty.clearFilters': '清除筛选',
  'products.empty.imageSearch': '按图片查找相似产品',

  // Pagination
  'products.pagination.showing': '显示第 {{start}}–{{end}} 条，共 {{total}} 条',
  'products.pagination.prev': '上一页',
  'products.pagination.next': '下一页',

  // Bottom CTA
  'products.bottomCTA.title': '需要帮助寻找合适的包装？',
  'products.bottomCTA.text': '上传参考图片，或向我们的团队请求定制包装报价。',
  'products.bottomCTA.imageSearch': '按图片查找相似产品',
  'products.bottomCTA.requestQuote': '请求报价',

  // Market indicator
  'products.market.label': '市场',
  'products.currency.label': '货币',
  'products.baseCurrency.label': '基础报价货币',

  // Search status
  'products.searchingByImage': '正在按图片搜索...',
  'products.searchingProducts': '正在搜索产品...',
  'products.imageSearchResult': '根据您上传的图片找到 {{count}} 个相似产品。',
  'products.textSearchResult': '为 "{{query}}" 找到 {{count}} 个产品。',
  'products.noSimilarProducts': '未找到相似产品。请尝试其他图片或调整筛选条件。',
  'products.noProductsFoundForQuery': '未找到 "{{query}}" 的相关产品。请调整搜索词。',
  'products.imageSearchFailed': '图片搜索失败。请使用其他图片重试。',
  'products.imageSearchUnavailable': '图片搜索服务当前不可用。',
  'products.apiRouteNotFound': '未找到 API 路由。请检查 Cursor API 路由 /api/customer/image-search 及代理设置。',
  'products.showingAllProducts': '改为显示全部产品。',
  'products.textSearchLocalFallback': '服务器搜索不可用。为 "{{query}}" 显示 {{count}} 个本地结果。',
  'products.searchFailed': '搜索失败，请重试。',
  'products.clearSearch': '清除搜索',
  'products.imageSearchLabel': '图片搜索',
  'products.textSearchLabel': '文本搜索',

  // Image Search Flow
  'products.imageSearch.uploaded': '图片已上传。',
  'products.imageSearch.jobCreated': '图片搜索任务已创建。',
  'products.imageSearch.startingEdgeFunction': '正在启动 Edge Function...',
  'products.imageSearch.analyzingImage': '正在分析图片...',
  'products.imageSearch.searchingSimilar': '正在搜索相似产品...',
  'products.imageSearch.preparingResults': '正在整理结果...',
  'products.imageSearch.completed': '根据您上传的图片找到 {{count}} 个相似产品。',
  'products.imageSearch.failed': '图片搜索失败。请尝试其他图片。',
  'products.imageSearch.signInRequired': '请登录后使用图片搜索。',
  'products.imageSearch.invalidFile': '仅支持 JPG、PNG 或 WEBP 文件。',
  'products.imageSearch.tooLarge': '图片必须小于 10MB。',
  'products.imageSearch.timeout': '图片搜索耗时超出预期。您可以保持此页面打开或重试。',
  'products.imageSearch.edgeFunctionFailed': '无法启动 Edge Function，请重试。',

  // Image Search Monitor
  'products.imageSearch.monitor.title': '图片搜索监控',
  'products.imageSearch.monitor.jobId': '任务 ID',
  'products.imageSearch.monitor.status': '状态',
  'products.imageSearch.monitor.step': '步骤',
  'products.imageSearch.monitor.progress': '进度',
  'products.imageSearch.monitor.message': '消息',
  'products.imageSearch.monitor.uploadedImage': '已上传图片',
  'products.imageSearch.monitor.createdAt': '创建时间',
  'products.imageSearch.monitor.startedAt': '开始时间',
  'products.imageSearch.monitor.completedAt': '完成时间',
  'products.imageSearch.monitor.errorCode': '错误代码',
  'products.imageSearch.monitor.errorMessage': '错误消息',
  'products.imageSearch.monitor.timeline': '时间线',
  'products.imageSearch.monitor.invokeStatus': '函数调用',
  'products.imageSearch.monitor.invokeInvoking': '调用中...',
  'products.imageSearch.monitor.invokeInvoked': '已调用',
  'products.imageSearch.monitor.invokeFailed': '调用失败',

  // Image Search Modal
  'products.imageSearch.uploadDescription': '上传参考图片以查找相似的包装。',
  'products.imageSearch.dropHere': '将图片拖放到此处',
  'products.imageSearch.orClick': '或点击浏览',
  'products.imageSearch.upload': '上传',
  'products.imageSearch.camera': '拍照',
  'products.imageSearch.takePhoto': '拍摄照片',
  'products.imageSearch.reupload': '重新上传',
  'products.imageSearch.cancel': '取消',
  'products.imageSearch.searchButton': '查找相似',

  // List page misc
  'products.clearResult': '清除结果',
  'products.filters.activeCount': '已应用 {{count}} 项',
  'products.filters.noShapeData': '暂无形状数据。',
  'products.filters.noNeckSizeData': '暂无瓶口尺寸数据。',
  'products.filters.noUsageData': '暂无用途数据。',
  'products.filters.noPriceData': '暂无价格数据。',
  'products.filters.noMoqData': '暂无 MOQ 数据。',
  'products.card.noImage': '暂无图片',

  // Detail page
  'detail.breadcrumbHome': '首页',
  'detail.breadcrumbPackaging': '包装',
  'detail.addedToCart': '已加入购物车！({{count}} 件)',
  'detail.loading': '正在加载产品信息...',
  'detail.notFoundTitle': '未找到产品',
  'detail.notFoundDesc': '该产品不存在或已被删除。',
  'detail.backToList': '返回产品列表',
  'detail.inquiry': '咨询',
  'detail.leadTime': '交货期',
  'detail.selectedFinishing': '已选后加工 ({{count}})',
  'detail.reset': '重置',
  'detail.finishingNote': '已在后加工预览中选择 · 请求报价时自动应用',
  'detail.priceReference': '参考价格',
  'detail.perUnit': '每件',
  'detail.requestQuoteInquiry': '报价咨询',
  'detail.orderQuantity': '订购数量 (MOQ)',
  'detail.priceEstimateNote': '此为预估金额，制作报价单时最终确认。',
  'detail.moqBelowTitle': '低于最低起订量 (MOQ)',
  'detail.moqBelowDesc': '该产品的 MOQ 为 {{moq}}。低于 MOQ 的订单可能会产生额外费用或被拒绝。',
  'detail.sampleOnly': '仅购买样品',
  'detail.samplePriceNote': '此为参考价格。不同数量的单价、后加工、汇率及最终交易条件将在报价单中确认。',
  'detail.samplePurchase': '样品购买',
  'detail.sampleRange': '(0-50 件)',
  'detail.sampleBasePrice': '样品基础价格',
  'detail.tabDetails': '产品详情',
  'detail.tabReviews': '购买评价',
  'detail.specifications': '产品规格',
  'detail.features': '主要特点',
  'detail.saveProduct': '收藏',
  'detail.shareProduct': '分享',
  'detail.addToCart': '加入购物车',
  'detail.requestQuote': '后加工 & 获取报价',
  'detail.noReviews': '暂无评价',
  'detail.noReviewsDesc': '成为第一个为这款产品留下评价的人。',
  'detail.reviewCount': '{{count}} 条评价',
  'detail.expand': '更多',
  'detail.collapse': '收起',
  'detail.noSpecs': '暂无产品规格。',
  'detail.noImage': '暂无图片',
  'detail.imageNotAvailable': '图片无法显示',
  'detail.myFinishingImages': '我的后加工图片',

  // Finishing preview page
  'finishing.title': '后加工预览',
  'finishing.material': '材质',
  'finishing.capacity': '容量',
  'finishing.moq': 'MOQ',
  'finishing.refPrice': '参考单价',
  'finishing.quoteInquiry': '报价咨询',
  'finishing.selectOptions': '选择后加工选项',
  'finishing.selectOptionsDesc': '请按 部位 → 后加工方式 → 颜色 的顺序选择。可以对不同部位分别指定。',
  'finishing.resetAll': '全部重置',
  'finishing.selectPart': '选择部位',
  'finishing.selectMethod': '后加工方式',
  'finishing.selectColor': '选择颜色',
  'finishing.done': '已选择',
  'finishing.methodsCount': '{{count}} 种方式',
  'finishing.selectPartFirst': '- 请先选择部位',
  'finishing.selectPartHint': '在左侧选择部位后，<br />将显示可用的后加工方式。',
  'finishing.selectMethodFirst': '- 请先选择方式',
  'finishing.confirmHint': '- 请按确认按钮',
  'finishing.selectMethodHint': '在中间选择后加工方式后，<br />即可指定颜色。',
  'finishing.popularColors': '热门颜色',
  'finishing.premium': 'Premium',
  'finishing.custom': '自定义',
  'finishing.changeColor': '更改颜色',
  'finishing.changeColorHint': '您可以更改颜色或选择其他后加工方式。',
  'finishing.reselect': '重新选择',
  'finishing.confirm': '确认',
  'finishing.selectedCount': '已选择 {{count}} 项后加工',
  'finishing.optionsIncluded': '请求报价时将一并提交这些选项。',
  'finishing.generating': '生成中...',
  'finishing.aiPreviewButton': 'AI 后加工预览',
  'finishing.original': '原图',
  'finishing.aiFinished': 'AI 后加工',
  'finishing.aiGenerating': '正在生成 AI 图片...',
  'finishing.aiFailed': 'AI 图片生成失败',
  'finishing.aiFailedHint': '请参考原图与已选择的后加工信息。',
  'finishing.retry': '再试一次',
  'finishing.aiImage': 'AI 后加工图片',
  'finishing.aiImageHint': '选择后加工选项并<br />按下 AI 图片处理按钮',
  'finishing.summary': '后加工摘要',
  'finishing.summaryDesc': '所选的后加工条件将以结构化 JSON 形式发送到服务器。服务器生成 AI 提示词并制作图片。',
  'finishing.selectionSummary': '选择摘要',
  'finishing.additionalRequest': '附加要求 (可选)',
  'finishing.additionalRequestHint': '附加要求将随结构化后加工条件一并发送到服务器。',
  'finishing.generatePreview': '生成预览',
  'finishing.progressTitle': '预览生成进度',
  'finishing.currentStatus': '当前状态',
  'finishing.elapsed': '已用时',
  'finishing.message': '消息',
  'finishing.complete': '预览完成',
  'finishing.aiPreview': 'AI 预览',
  'finishing.generateAgain': '重新生成',
  'finishing.useThisPreview': '使用此预览',
  'finishing.viewEstimate': '查看后加工报价',
  'finishing.failed': '预览生成失败',
  'finishing.retryBtn': '重试',
  'finishing.editOptions': '编辑选项',
  'finishing.cancelAndBack': '取消并返回',
  'finishing.applySave': '应用并保存 {{count}} 项后加工',
  'finishing.saveUse': '保存后加工图片',
  'finishing.colorCount': '{{count}} 种颜色',
  'finishing.cancel': '取消',
  'finishing.pantoneCode': 'Pantone 色号',
  'finishing.hexCode': '颜色代码 (HEX)',
  'finishing.customColorHint': '请直接输入所需的 Pantone 色号和颜色。',
  'finishing.pantonePlaceholder': '例如：Pantone 185 C',
  'finishing.noPantone': '未指定 Pantone',
  'finishing.selectThisColor': '选择此颜色',
  'finishing.customName': '自定义',
  'finishing.pantoneRequired': '请输入 Pantone 色号。',
  'finishing.hexInvalid': '请输入有效的 HEX 颜色代码。(例如：#FF6B6B)',
  'finishing.metallic': '金属色',
  'finishing.pearl': '珠光',
  'finishing.softTouch': '柔软触感',
  'finishing.additionalRequestPlaceholder': '例如："做出高级感。"\n"使用干净的影棚背景。"\n"让瓶身保持优雅简约。"',
};